import React, { useMemo, useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import axios from 'axios';
import NavBar from '../Components/NavBar/NavBar';
import UserSlice from '../Slices/User';
import UserOnly from '../Components/Auth/UserOnly';
import GuestOnly from '../Components/Auth/GuestOnly';
import Login from '../Components/Auth/Login';
import Base from '../Components/Auth/Base';
import DocumentMeta from 'react-document-meta';
import { ToastProvider } from 'react-toast-notifications';
import Customer from '../Components/Customer/Customer';
import Campaign from '../Components/Master/Campaign';
import CampaignPage from '../Components/Master/CampaignPage';
import CampaignImage from '../Components/Master/CampaignImage';
import CampaignPush from '../Components/Master/CampaignPush';
import CampaignIcon from '../Components/Master/CampaignIcon';
import CampaignPoints from '../Components/Master/CampaignPoints';
import Coupon from '../Components/Master/Coupon';
import ShopGroup from '../Components/Master/ShopGroup';
import CouponCode from '../Components/Master/CouponCode';
import CustomerDetail from '../Components/Customer/CustomerDetail';
import Ticket from '../Components/Master/Ticket';
import Mall from '../Components/Master/Mall';
import Setting from '../Components/Master/Setting';
import PaymentHistory from '../Components/Customer/PaymentHistory';
import User from '../Components/Master/User';
import CustomerRank from '../Components/Master/CustomerRank';
import CampaignEntry from '../Components/Campaign/CampaignEntry';
import QRApp from '../Components/QRPoint/QRApp';
import CustomerReceipt from '../Components/Customer/CustomerReceipt';
import Shop from '../Components/Master/Shop';
import Cashier from '../Components/Master/Cashier';
import Stampcard from '../Components/Master/Stampcard';
import PointHistory from '../Components/Point/PointHistory';
import FirstBonus from '../Components/Master/FirstBonus';
import PointCampaign from '../Components/Master/PointCampaign';
import BonusPoint from '../Components/Master/BonusPoint';
import MonthlyDownload from '../Components/Point/MonthlyDownload';
import CouponDetail from '../Components/Master/CouponDetail';
import CouponGroup from '../Components/Master/CouponGroup';
import Event from '../Components/Master/Event';
import EventInfo from '../Components/Master/EventInfo';
import RankUpBonusDownload from '../Components/Point/RankUpBonusDownload';
import AppLottery from '../Components/Master/AppLottery';
import AppLotteryBonus from '../Components/Master/AppLotteryBonus';
import EntryType from '../Components/Master/EntryType';
import EntryTypeEdit from '../Components/Master/EntryTypeEdit';
import Questionnaire from '../Components/Master/Questionnaire';
import BenefitLotteryTicket from '../Components/Master/BenefitLotteryTicket';
import Lottery from '../Components/Master/Lottery';
import AfterPoint from '../Components/Master/AfterPoint';
import Schedule from '../Components/Master/Schedule';
import CheckinPointCampaign from '../Components/Master/CheckinPointCampaign';
import Terminal from '../Components/Master/Terminal';

const useActions = (actions, deps) => {
  const dispatch = useDispatch();
  return useMemo(
    () => {
      if (Array.isArray(actions)) {
        return actions.map(a => bindActionCreators(a, dispatch))
      }
      return bindActionCreators(actions, dispatch)
    },
    deps ? [dispatch, ...deps] : [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )
};

const BackApp = (props) => {
  const userActions = useActions(UserSlice.actions);
  const user = useSelector(state => state.User);
  const [siteName, setSiteName] = useState();
  const [meta, setMeta] = useState({});
  const [setting, setSetting] = useState(null);

  const getSiteName = async (siteId, mallId) => {
    const site = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/site/search/`, { site_id: siteId })).data;
    const mall = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}/${mallId}`)).data;

    const setting = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/setting/${siteId}/`)).data;
    setSiteName(site ? `${site.site_name}${mall ? `\n(${mall.mall_name})` : ''}` : '');
    const temp = {
      link: {
        rel: {
          icon: `/${siteId}/favicon.ico`,
          "apple-touch-icon": `/${siteId}/logo192.png`,
          manifest: `/${siteId}/manifest.json`,
          stylesheet: `/${siteId}/style.css`,
        },
      },
      title: site ? `${site.site_name}${mall ? `(${mall.mall_name})` : ''}` : '',
      description: site ? site.site_name : '',
    }
    setMeta(temp);
    setSetting(setting);
  }

  useEffect(() => {
    getSiteName(props.match.params.siteId, props.match.params.mallId);
  }, [props.match.params.siteId, props.match.params.mallId]);

  const _userProps = { user, userActions, siteName, setting, ...props };
  return (
    <div className='backyard-top'>
      <DocumentMeta {...meta} />
      <Route path={`${props.match.path}`} render={() =>
        <Base {..._userProps}>
          <NavBar {..._userProps} />
          <ToastProvider placement="bottom-center">
            <Route render={() =>
              <UserOnly {..._userProps} >
                <Route exact path={`${props.match.path}`} >
                  <Customer {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}customer/:id`} >
                  <CustomerDetail {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaign`} >
                  <Campaign {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignpush`} >
                  <CampaignPush {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignicon/:id`} >
                  <CampaignIcon {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignpoints`} >
                  <CampaignPoints {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignpage`} >
                  <CampaignPage {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignpage/:id`} >
                  <CampaignPage {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignimage/:id`} >
                  <CampaignImage {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}campaignentry`} >
                  <CampaignEntry {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}coupon`} >
                  <Coupon {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}coupon/:id`} >
                  <CouponDetail {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}coupongroup`} >
                  <CouponGroup {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}shopgroup`} >
                  <ShopGroup {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}couponcode/:id`} >
                  <CouponCode {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}ticket`} >
                  <Ticket {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}mall`} >
                  <Mall {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}setting`} >
                  <Setting {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}paymenthistory`} >
                  <PaymentHistory {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}user`} >
                  <User {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}customerrank`} >
                  <CustomerRank {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}pointterminal`} >
                  <QRApp {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}pointterminal/:cardId`} >
                  <QRApp {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}customerreceipt`} >
                  <CustomerReceipt {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}shop`} >
                  <Shop {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}cashier/:shopId`} >
                  <Cashier {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}stampcard`} >
                  <Stampcard {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}pointhistory`} >
                  <PointHistory {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}pointhistory/:cardId`} >
                  <PointHistory {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}firstbonus`} >
                  <FirstBonus {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}pointcampaign`} >
                  <PointCampaign {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}bonuspoint`} >
                  <BonusPoint {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}event`} >
                  <Event {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}eventinfo/:eventId`} >
                  <EventInfo {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}applottery`} >
                  <AppLottery {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}applotterybonus/:lotteryId`} >
                  <AppLotteryBonus {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}entrytype`} >
                  <EntryType {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}entrytype/edit`} >
                  <EntryTypeEdit {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}entrytype/edit/:entry_type`} >
                  <EntryTypeEdit {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}questionnaire`} >
                  <Questionnaire {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}monthlydownload`} >
                  <MonthlyDownload {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}rankupbonusdownload`} >
                  <RankUpBonusDownload {..._userProps} />
                </Route>                                
                <Route exact path={`${props.match.path}benefitlotteryticket`} >
                  <BenefitLotteryTicket {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}lottery`} >
                  <Lottery {..._userProps} />
                </Route>
                <Route exact path={`${props.match.path}afterpoint`}>
                  <AfterPoint {..._userProps}/>
                </Route>
                <Route exact path={`${props.match.path}schedule`}>
                  <Schedule {..._userProps}/>
                </Route>
                <Route exact path={`${props.match.path}checkinpointcampaign`}>
                  <CheckinPointCampaign {..._userProps}/>
                </Route>
                <Route exact path={`${props.match.path}terminal`}>
                  <Terminal {..._userProps}/>
                </Route>
              </UserOnly>
            } />
            <Route render={() =>
              <GuestOnly {..._userProps} >
                <Route path={`${props.match.path}login`} render={() =>
                  <Login {..._userProps} />
                } />
              </GuestOnly>
            } />
          </ToastProvider>
        </Base>
      } />
    </div>
  );
}

export default BackApp;